import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  unarchiveProjectItemMutation,
  unarchiveProjectItemMutation$data,
  UnarchiveProjectV2ItemInput,
} from './__generated__/unarchiveProjectItemMutation.graphql'

export function commitUnArchiveProjectItem({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: UnarchiveProjectV2ItemInput
  onError?: (error: Error) => void
  onCompleted?: (response: unarchiveProjectItemMutation$data) => void
}) {
  return commitMutation<unarchiveProjectItemMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation unarchiveProjectItemMutation($input: UnarchiveProjectV2ItemInput!) @raw_response_type {
        unarchiveProjectV2Item(input: $input) {
          item {
            isArchived
          }
        }
      }
    `,
    variables: {
      input,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
